import React, { useState } from 'react';
import { 
  FiSearch, 
  FiFilter, 
  FiShield, 
  FiFileText, 
  FiClock, 
  FiUser,
  FiDownload
} from 'react-icons/fi';

const AuditLogs = () => {
  const [filterUser, setFilterUser] = useState('');
  const [filterSection, setFilterSection] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const colors = {
    primary: '#085e53',
    secondary: '#267c77',
    bg: '#f8fafc',
    text: '#333333'
  };

  // Mock Log Data
  const logs = [
    {
      id: 'LOG-1005',
      user: 'अमित पाटील',
      role: 'Super Admin',
      action: 'LOGIN',
      section: 'System',
      description: 'यशस्वी लॉगिन',
      timestamp: '२०/०२/२०२६ १०:३०:४५',
      ip: '192.168.1.10'
    },
    {
      id: 'LOG-1004',
      user: 'सुप्रिया काळे',
      role: 'GP Admin',
      action: 'UPDATE',
      section: 'Application',
      description: 'इनाम धामणी: अर्ज क्र. APP-1002 मंजूर केला',
      timestamp: '२०/०२/२०२६ १०:१५:२०',
      ip: '192.168.1.15'
    },
    {
      id: 'LOG-1003',
      user: 'रमेश जाधव',
      role: 'Data Operator',
      action: 'CREATE',
      section: 'Tax',
      description: 'नवीन घरपट्टी आकारणी नोंदणी',
      timestamp: '२०/०२/२०२६ ०९:४५:१०',
      ip: '192.168.1.20'
    },
    {
      id: 'LOG-1002',
      user: 'अमित पाटील',
      role: 'Super Admin',
      action: 'SETTINGS',
      section: 'Configuration',
      description: 'SMS API की अपडेट केली',
      timestamp: '१९/०२/२०२६ १६:२०:००',
      ip: '192.168.1.10'
    },
    {
      id: 'LOG-1001',
      user: 'System',
      role: 'System',
      action: 'BACKUP',
      section: 'Database',
      description: 'स्वयंचलित रोजचा बॅकअप पूर्ण',
      timestamp: '१९/०२/२०२६ ००:००:०१',
      ip: 'localhost'
    }
  ];

  const getActionColor = (action) => {
    switch(action) {
      case 'LOGIN': return 'text-green-600 bg-green-50 border-green-200';
      case 'DELETE': return 'text-red-600 bg-red-50 border-red-200';
      case 'UPDATE': return 'text-blue-600 bg-blue-50 border-blue-200';
      case 'CREATE': return 'text-purple-600 bg-purple-50 border-purple-200';
      case 'BACKUP': return 'text-gray-600 bg-gray-50 border-gray-200';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  return (
    <div className="p-6 min-h-screen" style={{ backgroundColor: colors.bg }}>
      <div className="mb-6 flex flex-col md:flex-row justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold mb-1" style={{ color: colors.primary }}>लेखा परीक्षण नोंदी (Audit Logs)</h1>
          <p className="text-gray-600 text-sm">सिस्टममधील सर्व हालचालींची आणि बदलांची नोंद.</p>
        </div>
        <div className="flex gap-2 mt-4 md:mt-0">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-50 shadow-sm transition-colors">
            <FiDownload /> Excel निर्यात
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-50 shadow-sm transition-colors">
            <FiDownload /> PDF अहवाल
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
          <div className="p-3 bg-blue-50 text-blue-600 rounded-lg">
            <FiClock size={24} />
          </div>
          <div>
            <div className="text-gray-500 text-xs">आजचे लॉग</div>
            <div className="text-xl font-bold text-gray-800">१४५</div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
          <div className="p-3 bg-purple-50 text-purple-600 rounded-lg">
            <FiFileText size={24} />
          </div>
          <div>
            <div className="text-gray-500 text-xs">अर्ज क्रिया</div>
            <div className="text-xl font-bold text-gray-800">३२</div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
          <div className="p-3 bg-green-50 text-green-600 rounded-lg">
            <FiShield size={24} />
          </div>
          <div>
            <div className="text-gray-500 text-xs">सुरक्षा अलर्ट</div>
            <div className="text-xl font-bold text-gray-800">०</div>
          </div>
        </div>
        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-4">
          <div className="p-3 bg-orange-50 text-orange-600 rounded-lg">
            <FiUser size={24} />
          </div>
          <div>
            <div className="text-gray-500 text-xs">लॉगिन सत्रे</div>
            <div className="text-xl font-bold text-gray-800">१२</div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6 flex flex-col lg:flex-row gap-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 flex-1">
          <div className="col-span-1 md:col-span-2 flex gap-2">
            <div className="w-1/2">
               <label className="block text-xs font-medium text-gray-500 mb-1">तारखेपासून (From)</label>
               <input 
                 type="date" 
                 className="w-full p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none"
                 onChange={(e) => setStartDate(e.target.value)}
               />
            </div>
            <div className="w-1/2">
               <label className="block text-xs font-medium text-gray-500 mb-1">तारखेपर्यंत (To)</label>
               <input 
                 type="date" 
                 className="w-full p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none"
                 onChange={(e) => setEndDate(e.target.value)}
               />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">वापरकर्ता (User)</label>
            <select 
              className="w-full p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none"
              onChange={(e) => setFilterUser(e.target.value)}
            >
              <option value="">सर्व वापरकर्ते</option>
              <option value="superadmin">सुपर ॲडमिन</option>
              <option value="gpadmin">ग्रामपंचायत ॲडमिन</option>
              <option value="operator">डेटा ऑपरेटर</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">विभाग (Section)</label>
            <select 
              className="w-full p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none"
              onChange={(e) => setFilterSection(e.target.value)}
            >
              <option value="">सर्व विभाग</option>
              <option value="login">लॉगिन / सुरक्षा</option>
              <option value="application">अर्ज प्रणाली</option>
              <option value="finance">आर्थिक व्यवहार</option>
              <option value="settings">सेटिंग्ज</option>
            </select>
          </div>
        </div>
        <button 
          className="px-6 py-2 text-white font-medium rounded-lg shadow-sm hover:opacity-90 transition-opacity self-end"
          style={{ backgroundColor: colors.primary }}
        >
          <FiSearch className="inline mr-2" /> शोधा
        </button>
      </div>

      {/* Logs Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-50 text-gray-700 text-sm">
              <th className="p-4 font-semibold border-b w-16">ID</th>
              <th className="p-4 font-semibold border-b">वापरकर्ता</th>
              <th className="p-4 font-semibold border-b">क्रिया (Action)</th>
              <th className="p-4 font-semibold border-b">विभाग</th>
              <th className="p-4 font-semibold border-b">वर्णन</th>
              <th className="p-4 font-semibold border-b">दिनांक व वेळ</th>
              <th className="p-4 font-semibold border-b">IP Address</th>
            </tr>
          </thead>
          <tbody className="text-sm divide-y divide-gray-100">
            {logs.map((log) => (
              <tr key={log.id} className="hover:bg-gray-50">
                <td className="p-4 font-mono text-xs text-gray-400">#{log.id.split('-')[1]}</td>
                <td className="p-4">
                  <div className="font-medium text-gray-800">{log.user}</div>
                  <div className="text-xs text-gray-500">{log.role}</div>
                </td>
                <td className="p-4">
                  <span className={`px-2 py-1 rounded text-xs font-bold border ${getActionColor(log.action)}`}>
                    {log.action}
                  </span>
                </td>
                <td className="p-4 text-gray-600">{log.section}</td>
                <td className="p-4 text-gray-800 font-medium">{log.description}</td>
                <td className="p-4 text-gray-600 font-mono text-xs">
                  <FiClock className="inline mr-1 text-gray-400 mb-0.5" />
                  {log.timestamp}
                </td>
                <td className="p-4 text-gray-500 font-mono text-xs">{log.ip}</td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {/* Pagination Placeholder */}
        <div className="p-4 border-t bg-gray-50 text-xs text-gray-500 flex justify-between items-center">
          <span>एकूण ५०० पैकी १-५ रेकॉर्ड</span>
          <div className="flex gap-2">
            <button className="px-3 py-1 bg-white border rounded hover:bg-gray-100 disabled:opacity-50" disabled>मागील</button>
            <button className="px-3 py-1 bg-white border rounded hover:bg-gray-100">पुढील</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditLogs;
